import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicOrganisation } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const getOrganisations = async (
  search?: string,
): Promise<PublicOrganisation[]> => {
  const response = await axiosClient.get("/organisations", {
    params: { search },
  });
  return response.data;
};

export function useGetOrganisations(
  queryOptions?: Partial<UseQueryOptions<PublicOrganisation[], HttpError>>,
  search?: string,
) {
  return useQuery({
    queryKey: ["organisations"],
    queryFn: () => getOrganisations(search),
    ...queryOptions,
  });
}
